import { render, staticRenderFns } from "./MaxWordsHomeworkCard.vue?vue&type=template&id=302e5636&scoped=true"
import script from "./MaxWordsHomeworkCard.vue?vue&type=script&lang=ts"
export * from "./MaxWordsHomeworkCard.vue?vue&type=script&lang=ts"
import style0 from "./MaxWordsHomeworkCard.vue?vue&type=style&index=0&id=302e5636&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302e5636",
  null
  
)

export default component.exports